export default __webpack_public_path__ + "static/media/create-supply-package-icon.967f8b45.svg";